import { createTheme } from '@material-ui/core';
import { green } from '@material-ui/core/colors';

let theme = createTheme({
    palette: {
        primary: {
            light: '#242b55',
            main: '#37517E',
            dark: '#5c6494',
            contrastText: '#fff',
        },
        secondary: green,
    },
	typography: {
		button: {
			textTransform: 'none'
		}
	},
	overrides: {
		MuiCssBaseline: {
			'@global': {
				'::-webkit-scrollbar': {
					width: '8px',
					height: '8px'
				  },
				  /* Track */
				  '::-webkit-scrollbar-track': {
					background: '#f1f1f1'
				  },
				  /* Handle */
				  '::-webkit-scrollbar-thumb': {
					background:' #888'
				  },
				  /* Handle on hover */
				  '::-webkit-scrollbar-thumb:hover': {
					background: '#555'
				  }
			}
		  }
	},
});

export default theme;
